<i18n>
{
	"en": {
		"operationalStatus": "Operational status",
		"cancelled": "Cancelled",
		"draft": "Draft",
		"received": "Received",
		"rejected": "Rejected",
		"ready": "Ready",
		"planned": "Planned",
		"unsuccessful": "Unsuccessful",
		"requested": "Requested",
		"accepted": "Accepted",
		"loaded": "Loaded",
		"unloaded": "Unloaded",
		"readyForPickup": "Ready for Pickup",
		"selectStatus": "Select status"
	},
	"no": {
		"operationalStatus": "Operativ status",
		"cancelled": "Annullert",
		"draft": "Kladd",
		"received": "Mottatt",
		"rejected": "Avslått",
		"ready": "Klar",
		"planned": "Planlagt",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Akseptert",
		"loaded": "Lastet",
		"unloaded": "Losset",
		"readyForPickup": "Klar for henting",
		"selectStatus": "Velg status"
	}
}
</i18n>

<template>
	<t-form-group :title="$t('operationalStatus')" rowGap="5px">
		<t-select
			:selectedItem="selectedItem"
			:selectedItems="selectedItems"
			:items="orderStatuses"
			:disabled="disabled"
			:relative="relative"
			showPopoverOnFocus
			:enableFocusNextOnKeyboardSelect="enableFocusNextOnKeyboardSelect"
			@change="$emit('change', $event)"
			@select="$emit('select', $event)"
		>
			<template #displayedValue>
				<div v-if="selectedItem != undefined" class="list-item">
					<t-status-color-dot :color="getStatusColor(selectedItem)" />
					<div>
						{{ $t(getOrderStatus(selectedItem)) }}
					</div>
				</div>
				<div v-else>{{ $t('selectStatus') }}</div>
			</template>
			<template #optionItemValue="{ item }">
				<div class="list-item">
					<t-status-color-dot :color="getStatusColor(item)" />
					<div>
						{{ $t(getOrderStatus(item)) }}
					</div>
				</div>
			</template>
			<!-- This will enables slots to be overwritten if the slot is defined further out -->
			<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
				<slot :name="slot" v-bind="scope"/>
			</template>
		</t-select>
		<slot name="after" />
	</t-form-group>
</template>

<script>
import { statuses } from '@/core';

export default {
	name: 'OrderStatusesFormInput',
	props: {
		selectedItem: Number,
		selectedItems: {
			type: Array,
			default: () => []
		},
		relative: Boolean,
		disabled: {
			type: Boolean,
			default: false
		},
		enableFocusNextOnKeyboardSelect: Boolean,
	},
	computed: {
		orderStatuses() {
			return Object.values(statuses.order);
		},
	},
	methods: {
		getOrderStatus(value) {
			return statuses.order(value);
		},
		getStatusColor(value) {
			return statuses.color(value);
		},
	}
};
</script>

<style lang="scss" scoped>
.list-item {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	> * {
		margin-right: 5px;
	}
}
</style>